import { render, staticRenderFns } from "./PcSideChatMessage.vue?vue&type=template&id=c16e0fa6&scoped=true&"
import script from "./PcSideChatMessage.vue?vue&type=script&lang=ts&"
export * from "./PcSideChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PcSideChatMessage.vue?vue&type=style&index=0&id=c16e0fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16e0fa6",
  null
  
)

export default component.exports